<template>
  <div>
    <Header />

    <input
      class="toggle"
      id="offCanvas"
      type="checkbox"
    >
    <div class="wrapper">

      <!-- Sidebar -->
      <nav id="sidebar">
        <Sidebar :item="item" />
      </nav>
      <!-- Sidebar -->
      <nav id="lg-sidebar">
        <Sidebar :item="item" />
      </nav>

      <!-- Page Content -->
      <div id="content">
        <div class="container">
          <router-view></router-view>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/employeeHeader";
import Sidebar from "../../partials/employeeSidebar";

export default {
  name: "Layout",
  components: {
    Header,
    Sidebar
  },
  data() {
    return { item: "" };
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;

  #sidebar {
    min-height: 100vh;
    background: #fff;
    border-top: 5px solid #fbfafa;
    padding-top: 26px;
    overflow: auto;
    width: 230px;
    margin-left: -230px;
    float: left;
    transition: all 0.2s ease;
    position: absolute;
    z-index: 99999;
  }

  #sidebar.active {
    margin-left: 0;
    width: 100%;
  }

  #content {
    float: right;
    margin-right: 0;
    background: #fbfafa;
  }

  #lg-sidebar {
    min-width: 230px;
    max-width: 230px;
    min-height: 100vh;
    background: #fff;
    border-top: 5px solid #fbfafa;
    padding-top: 26px;
    overflow: auto;
  }

  #lg-sidebar.active {
    margin-left: -250px;
  }

  @media (max-width: 800px) {
    #lg-sidebar {
      margin-left: -230px;
    }
    #lg-sidebar.active {
      margin-left: 0;
    }
  }
}

.toggle {
  display: none;
}
.toggle:checked + .wrapper > #sidebar {
  margin-left: 0;
  width: 100%;
}
</style>
